module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "center",
    staticStyle: {
      "margin-top": "50px"
    },
    attrs: {
      "id": "note"
    }
  }, [_vm._v("Author’s Note")]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('i', [_vm._v("Tapestry")]), _vm._v(" is a work of fiction. Though I have used actual places and times, I have treated these as I have seen fit, changing some as appropriate. Occasionally the name of a real person is used for historical authenticity, but all are deceased and I have made of them what the story demands. I do not condone what happened during these times. Indeed, I abhor it. But during the Occupation of France everyday crimes of murder and arson continued to be committed, and I merely ask, by whom and how were they solved?")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42241ddf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/7-note.vue
// module id = 78
// module chunks = 0